/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { SuccessIcon } from '@coursera/cds-icons';

import { getMaybeVerifiedLabel, isRoleVerified } from 'bundles/discussions/utils/userUtils';

export type PillTagProps = { label?: string; badge?: string; className?: string };

function PillTag({ label, badge, className }: PillTagProps) {
  const isVerifiedRole = isRoleVerified(badge);
  const processedLabel = getMaybeVerifiedLabel(isVerifiedRole, label);
  return (
    <Typography2
      css={css`
        padding: var(--cds-spacing-50) var(--cds-spacing-100) var(--cds-spacing-50) var(--cds-spacing-100);
        border-radius: 12px;
        color: var(--cds-color-purple-950);
        background-color: var(--cds-color-purple-25);
        display: inline-flex;
        align-items: center;
        gap: 4px;
        ${badge === 'NOT_ENROLLED' &&
        `
          color: var(--cds-color-red-700);
          background-color: var(--cds-color-red-25);
        `}
        ${badge === 'LEARNER' &&
        `
          color: var(--cds-color-blue-800);
          background-color: var(--cds-color-blue-25);
        `}
  ${label === 'Closed' &&
        `
          color: var(--cds-color-red-700);
          background-color: var(--cds-color-red-25);
        `}
      `}
      component="div"
      variant="subtitleMedium"
      aria-label={processedLabel}
      className={className}
    >
      {isVerifiedRole && <SuccessIcon size="medium" title={processedLabel} data-testid="verified-icon" />}
      {processedLabel}
    </Typography2>
  );
}

export default PillTag;
